import { render, staticRenderFns } from "./ReModeration.vue?vue&type=template&id=09dbdf06&scoped=true"
import script from "./ReModeration.vue?vue&type=script&lang=js"
export * from "./ReModeration.vue?vue&type=script&lang=js"
import style0 from "./ReModeration.vue?vue&type=style&index=0&id=09dbdf06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dbdf06",
  null
  
)

export default component.exports